/* src/app/modules/product-labels/flag-label/flag-label.component.scss */
.product-label {
  padding: 0;
}
.triangles-for-flag {
  margin-right: -1px;
}
.flag-body {
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.075em;
  text-align: center;
  padding: 0.1rem 0.25rem;
}
/*# sourceMappingURL=flag-label.component.css.map */
